import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './KioskConfimPickupLayout.styles';
// import { Paper } from '@material-ui/core';
import {
  KioskFooter,
  KioskHeader,
  KioskConfimPickupMain,
  KioskIdelScreen
} from '..';
import KioskTouchSound from '../Kiosk/TouchSound';
export class KioskConfimPickupLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };

  playTouchSound = () => {
    //e.preventDefault();
    let sound = document.getElementById('touchSound');
    sound.play();
  };
  render() {
    const { classes } = this.props;
    var customFooterBottom;
    if (window.screen.width === 1440 || window.screen.width === 1920) {
      customFooterBottom = '-25%';
    } else {
      customFooterBottom = '0%';
    }
    return (
      <div
        onClick={() => {
          this.playTouchSound();
        }}
        className={classNames(classes.container)}
      >
        <KioskHeader />
        <KioskConfimPickupMain />
        <KioskFooter
          customFooterBottom={customFooterBottom}
          isLanguageBarAllowd={true}
        />
        <KioskIdelScreen />
        <KioskTouchSound />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(KioskConfimPickupLayout);
